module.exports = __webpack_public_path__ + "media/in_destinum/img/background-aae4c1776d44a73d8ba14eee5feec7c0.png";